import React from "react";
import TehranInventory from "./containers/TehranInventoryDashboard/TehranInventory";
import FactoriesInventory from "./containers/FactoryInventory/FactoryInventory";
import IsfahanInventory from "./containers/IsfahanInventory/IsfahanInventory";
import WelcomePage from "./containers/WelcomePage/welcomePage";
import MiscellaneousInventory from "./containers/MiscellaneousInventory/Miscellaneous";
import TVInventory from "./containers/TV/tv";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";

export default function App() {

  return (
    <div className="center">
      <Router>
        <Routes>
          <Route path="/" element={<WelcomePage/>} />
          <Route path="/home" element={<WelcomePage/>} />
          <Route path="/TV" element={<TVInventory/>} />
          <Route path="/tehran" element={<TehranInventory/>} />
          <Route path="/factory" element={<FactoriesInventory/>} />
          <Route path="/isfahan" element={<IsfahanInventory/>} />
          <Route path="/miscellaneous" element={<MiscellaneousInventory/>} />
        </Routes>
      </Router>
    </div>
  );
}

